import styles from "./main.module.css";

function Main() {
	return (
		<div className={styles.main}>
			<h2 className={styles.main_title}>Расширяй словарный запас интересно, вместе с RSLang</h2>
		</div>
	)
}

export default Main
